<template>
    <div>
      <template>
        <!-- <v-container>
          <div style="border-radius: 15px; border: 1px solid #eee; overflow: hidden">
            <v-layout wrap>
              <v-flex
                xs12
                sm6
                style="background: url(../static/img/shippop.png); background-position: center;
      background-repeat: no-repeat;
      background-size: cover;min-height: 200px"
              >
              </v-flex>
              <v-flex xs12 sm6 class="text-xs-center px-2 py-4">
                <v-layout justify-center align-center row style="height: 100%">
                  <v-flex>
                    <div>
                      {{ $t('One Stop Delivery Solution') }}
                    </div>
                    <div class="mb-2">
                      SHIPPOP X ZWIZ.AI
                    </div>
                    <v-btn depressed color="primary" large @click="gotoshippop">
                      {{ $t('Details') }}
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </div>
        </v-container> -->
  
        <v-container id="shippop">
          <shippop-manage></shippop-manage>
        </v-container>
      </template>
  
      <template>
        <v-divider></v-divider>
        <v-container>
          <akita-manage></akita-manage>
        </v-container>
      </template>
  
      <template>
        <v-divider />
        <v-container>
          <packhai-manage></packhai-manage>
        </v-container>
      </template>
  
      <template>
        <v-divider />
        <v-container v-if="selectedBot">
          <sokochan-manage></sokochan-manage>
        </v-container>
      </template>
  
      <template>
        <v-divider />
        <v-container v-if="selectedBot">
          <zort-out-manage></zort-out-manage>
        </v-container>
      </template>
  
      <template>
        <v-divider />
        <v-container v-if="selectedBot">
          <scg-manage></scg-manage>
        </v-container>
      </template>
  
      <template>
        <v-divider />
        <v-container v-if="selectedBot">
          <jandt-manage></jandt-manage>
        </v-container>
      </template>

      <!-- <template>
      <v-divider />
      <v-container v-if="selectedBot">
        <ninja-manage/>
      </v-container>
    </template> -->
  
      <div style="height: 60px"></div>
    </div>
  </template>
  
  <script>
  import { mapGetters } from 'vuex'
  import api from '@/api'
  
  import ShippingDetail from '@/components/view/setting/ecommerce/ShippingDetail'
  import ShippingAddress from '@/components/view/setting/ecommerce/ShippingAddress'
  import ShippopManage from './ShippopManage'
  import AkitaManage from './AkitaManage'
  import PackhaiManage from './PackhaiManage'
  import SokochanManage from './SokochanManage'
  import ZortOutManage from './ZortOutManage'
  import ScgManage from './ScgManage'
  import JandtManage from './JandtManage'
  import NinjaManage from './NinjaManage.vue'
  import { ToggleButton } from 'vue-js-toggle-button'
  
  export default {
    data() {
      return {
        isEditShippingAddress: false,
        isEditPaymentDetail: false,
        isTransfer: false,
        isCreditCard: false,
        contents: [],
        toggleSetWeight: false,
        toggleLineAutoSendOrderTrackingStatus: false
      }
    },
    components: {
      ShippingDetail,
      ShippopManage,
      AkitaManage,
      ShippingAddress,
      PackhaiManage,
      ToggleButton,
      SokochanManage,
      ZortOutManage,
      ScgManage,
      JandtManage,
      NinjaManage
    },
    mounted() {
      this.toggleSetWeight = this.selectedBot.is_display_transport_weight
      this.toggleLineAutoSendOrderTrackingStatus = this.selectedBot.line_auto_send_order_tracking_status
      this.getSetting()
    },
    computed: {
      ...mapGetters({
        selectedBot: 'selectedBot',
        currentLang: 'currentLang'
      })
    },
    methods: {
      async onChangeToggleLineAutoSendOrderTrackingStatus() {
        this.toggleLineAutoSendOrderTrackingStatus = !this.toggleLineAutoSendOrderTrackingStatus
        this.$store.dispatch('loading')
        var data = {
          body: { line_auto_send_order_tracking_status: this.toggleLineAutoSendOrderTrackingStatus },
          pageId: this.selectedBot.pageid
        }
        var res = await api.toggleWeightShipping(data)
        if (res.success) {
          this.$store.dispatch('updateBotDetail')
        } else {
          this.toggleLineAutoSendOrderTrackingStatus = !this.toggleLineAutoSendOrderTrackingStatus
        }
        this.$store.dispatch('loading')
      },
      gotoshippop() {
        this.$el.querySelector('[id="shippop"]').scrollIntoView()
      },
      getSetting: function() {
        let vm = this
        var data = {
          pageid: vm.selectedBot.pageid
        }
  
        api.getSetting(data, function(error, response) {
          if (error) {
            console.error(error)
            return
          }
          vm.contents = {}
          if (response.data) {
            response.data.map(function(setting, index) {
              vm.contents[setting.contenttype] = setting
              if (setting.contenttype === 'allowtransfer') {
                vm.isTransfer = setting.contentvalue
              }
              if (setting.contenttype === 'allowcreditcard') {
                vm.isCreditCard = setting.contentvalue
              }
            })
          }
        })
      }
    }
  }
  </script>
  
  <style lang="scss" scoped></style>
  


// WEBPACK FOOTER //
// src/components/view/template/ecommerce/ShippingConnect.vue